<template>
  <div>
    <el-card class="box-card">
      <el-row :gutter="35">
        <el-form :model="form" ref="form" inline label-width="auto" size="small" :rules="{}">
          <el-row>
            <el-form-item prop="formTime" :label="$t('orders.label.form.submitTime')">
              <range-date-picker ref="datePick" @showDateTime="handleShowDateTime" />
            </el-form-item>
            <el-form-item :label="$t('orders.label.table.payoutTime')">
              <range-date-picker
                :need-init="false"
                ref="payOutDatePick"
                @showDateTime="handleShowPayOutTime"
              />
            </el-form-item>
          </el-row>
          <el-form-item :label="$t('orders.label.form.merchatNo')">
            <el-input clearable v-model="form.query.merchantNo"></el-input>
          </el-form-item>
          <el-form-item :label="$t('wallet.label.merchatOrderNo')">
            <el-input clearable v-model="form.query.orderNo"></el-input>
          </el-form-item>
          <el-form-item :label="$t('orders.label.form.systemOrderNo')">
            <el-input clearable v-model="form.query.systemOrderNo"></el-input>
          </el-form-item>
          <el-form-item :label="$t('withdraw.label.paymentBank')">
            <el-input clearable v-model="form.query.accountBankCode"></el-input>
          </el-form-item>
          <el-form-item :label="$t('withdraw.label.paymentAccount')">
            <el-input clearable v-model="form.query.accountNumber"></el-input>
          </el-form-item>
          <el-form-item :label="$t('withdraw.label.paymentName')" prop="accountName">
            <el-input clearable v-model="form.query.accountName"></el-input>
          </el-form-item>
          <el-form-item :label="$t('orders.label.table.orderStatus')">
            <el-select filterable clearable v-model="form.query.orderStatus">
              <el-option
                v-for="key in Object.keys(orderStatusCode)"
                :label="orderStatusCode[key]"
                :key="key"
                :value="key"
              ></el-option>
              <el-option :label="$t('btns.emptyValue')" value=""></el-option>
            </el-select>
          </el-form-item>
          <el-form-item :label="$t('withdraw.label.paymentType')" v-if="userType == 0">
            <el-select filterable clearable v-model="form.query.type">
              <el-option
                v-for="item in paymentType"
                :key="item.value"
                :value="item.value"
                :label="item.label"
              ></el-option>
            </el-select>
          </el-form-item>
          <el-form-item style="margin-left: 20px">
            <el-button size="mini" type="primary" @click="handleEmpty()">{{
              $t('btns.empty')
            }}</el-button>
            <el-button size="mini" type="primary" @click="handleSearch()" :loading="searchLoading"
              >{{ $t('btns.search') }}
            </el-button>
            <el-button size="mini" type="success" @click="allOlder()">{{
              $t('btns.allOlder')
            }}</el-button>
          </el-form-item>
        </el-form>
      </el-row>
      <el-row style="margin-bottom: 20px">
        <el-col :span="16" :offset="15">
          <div>
            <el-switch
              v-if="true"
              v-model="refresh"
              @change="refTableData"
              :active-text="$t('btns.start1')"
              :inactive-text="$t('btns.stop1')"
            >
            </el-switch>
            <el-button
              v-if="tableData.length && permission.indexOf('orderRecord:payout:export') > -1"
              @click="handleExport()"
            >
              {{ $t('btns.export') }}
            </el-button>
          </div>
        </el-col>
      </el-row>
      <el-row>
        <div class="header-table">
          <ul class="list-table">
            <li class="li-table">
              <em class="label">
                <span>{{ $t('withdraw.label.payoutAmountCount') }}</span>
                <span>：</span>
              </em>
              <span class="value">{{ payoutCountInfo.paymentAmountTotal | toThousands }}</span>
            </li>
            <li class="li-table">
              <em class="label">
                <span>{{ $t('withdraw.label.payoutFeeCount') }}</span>
                <span>：</span>
              </em>
              <span class="value">{{ payoutCountInfo.handlingFeeTatal | toThousands }}</span>
            </li>
            <li class="li-table">
              <em class="label">
                <span>{{ $t('withdraw.label.paymentFixedFeeTatal') }}</span>
                <span>：</span>
              </em>
              <span class="value">{{
                payoutCountInfo.paymentFixedHandlingFeeTatal | toThousands
              }}</span>
            </li>
            <li class="li-table">
              <em class="label">
                <span>{{ $t('withdraw.label.autoSuccessAmount') }}</span>
                <span>：</span>
              </em>
              <span class="value">{{ payoutCountInfo.autoSuccessAmount | toThousands }}</span>
            </li>
            <li class="li-table" v-if="userType == 0">
              <em class="label">
                <span>{{ $t('withdraw.label.manualSuccessAmount') }}</span>
                <span>：</span>
              </em>
              <span class="value">{{ payoutCountInfo.manualSuccessAmount | toThousands }}</span>
            </li>
          </ul>
        </div>
        <el-table
          :data="tableData"
          v-loading="tableLoading"
          :header-cell-style="{ 'text-align': 'center' }"
          :cell-style="{ textAlign: 'center' }"
          :row-class-name="tableRowClassName"
          :row-key="rowKey"
          @selection-change="handleSelectionChange"
        >
          <el-table-column type="selection" width="55" :reserve-selection="true"> </el-table-column>
          <el-table-column type="index" label="#"></el-table-column>
          <el-table-column
            class-name="status-omit-colum"
            width="120px"
            prop="systemOrderNo"
            :label="$t('orders.label.table.systemOrderNo')"
          >
            <template slot-scope="{ row }">
              <div style="display: flex; align-items: center">
                <i
                  :title="$t('onlinememberdrawal.copy')"
                  class="fa fa-clipboard"
                  style="color: #777; cursor: pointer"
                  @click="copyText(row.systemOrderNo)"
                ></i>
                <router-link
                  class="rowcell"
                  v-if="userType === 0"
                  :to="{ name: 'transactionRecord', query: { systemOrderNo: row.systemOrderNo } }"
                >
                  {{ row.systemOrderNo }}
                </router-link>
                <span class="rowcell" v-else>
                  {{ row.systemOrderNo }}
                </span>
              </div>
            </template>
          </el-table-column>
          <el-table-column
            :label="$t('clientmanage.table.merchantNo')"
            prop="merchantNo"
          ></el-table-column>
          <el-table-column :label="$t('withdraw.label.merchatName')" prop="attribute2" />
          <el-table-column
            class-name="status-omit-colum"
            width="120px"
            :label="$t('wallet.label.merchatOrderNo')"
            prop="orderNo"
          >
            <template slot-scope="{ row }">
              <div style="display: flex; align-items: center">
                <i
                  :title="$t('onlinememberdrawal.copy')"
                  class="fa fa-clipboard"
                  style="color: #777; cursor: pointer"
                  @click="copyText(row.orderNo)"
                ></i>
                <span class="rowcell">{{ row.orderNo }}</span>
              </div>
            </template>
          </el-table-column>
          <el-table-column :label="$t('withdraw.label.bankCode')" prop="bankCode"></el-table-column>
          <el-table-column :label="$t('withdraw.label.bankNo')" prop="cardNumber"></el-table-column>
          <el-table-column
            :label="$t('withdraw.label.receiver')"
            prop="beneficiaryName"
          ></el-table-column>

          <el-table-column
            :label="$t('withdraw.label.paymentAccount')"
            prop="accountNumber"
            v-if="!info.userType"
          ></el-table-column>

          <el-table-column :label="$t('channelTest.label.amount')" prop="amount">
            <template slot-scope="{ row }">
              <span>{{ row.amount | toThousands }}</span
              ><br />
              <span v-if="row.attribute6" style="color: red">attacked</span>
            </template>
          </el-table-column>
          <el-table-column :label="$t('withdraw.label.handlingFee')" prop="fee">
            <template slot-scope="{ row }">
              {{ row.fee | toThousands }}
            </template>
          </el-table-column>
          <!-- 代付固定手续费 -->
          <el-table-column
            :label="$t('clientmanage.updataDia.payoutFixedFee')"
            prop="payoutFixedFee"
          >
            <template slot-scope="{ row }">
              {{ row.payoutFixedFee | toThousands }}
            </template>
          </el-table-column>
          <el-table-column :label="$t('orders.label.table.orderStatus')" prop="orderStatus">
            <template slot-scope="{ row }">
              <span>{{ orderStatusCode[row.orderStatus] }}</span>
            </template>
          </el-table-column>
          <el-table-column
            :label="$t('withdraw.label.applyTime')"
            prop="applyTime"
          ></el-table-column>
          <el-table-column
            :label="$t('withdraw.label.paymentAccount')"
            prop="accountNumber"
            v-if="!info.userType"
          ></el-table-column>
          <el-table-column
            :label="$t('withdraw.label.paymentBank')"
            prop="accountBankCode"
            v-if="!info.userType"
          ></el-table-column>
          <el-table-column
            :label="$t('withdraw.label.paymentName')"
            prop="accountName"
            v-if="!info.userType"
          ></el-table-column>
          <el-table-column
            :label="$t('merchantIp.label.operator')"
            prop="operatorName"
            v-if="!info.userType"
          ></el-table-column>
          <el-table-column
            v-if="!info.userType"
            :label="$t('device.remark')"
            prop="description"
            width="250"
          ></el-table-column>
          <el-table-column
            :label="$t('orders.label.table.payoutTime')"
            prop="payTime"
          ></el-table-column>
          <el-table-column
            :label="$t('withdraw.label.notifyTime')"
            prop="notifyTime"
          ></el-table-column>
        </el-table>
      </el-row>
      <v-pagination
        v-model="form"
        :sizes="[20, 50, 100, 500]"
        :size="form.size"
        :total="payoutOrderInfo.rows"
        @update="getMerchantPayoutOrderList"
      />
    </el-card>
    <el-dialog
      label="OTP"
      width="600px"
      height="400px"
      :visible.sync="showOtpDialog"
      :close-on-click-modal="false"
      v-loading="otpLoading"
      :title="optDialogTitle"
    >
      <el-card>
        <img
          v-if="
            (optInfo.transferInfo && optInfo.accountBankCode == 'MB') ||
            optInfo.accountBankCode == 'MSB'
          "
          :src="optInfo.transferInfo"
          style="width: 200px; margin: 0 auto; display: block"
        />
        <p v-else-if="optInfo.transferInfo && optInfo.transferInfo.length > 0" style="color: red">
          {{ $t('userTransaction.label.no') }}: <span>{{ optInfo.transferInfo }}</span>
        </p>
        <el-form ref="optForm" :model="optForm" :inline="true" style="padding: 40px 0">
          <el-form-item label="OTP" :rules="otpRules">
            <el-input clearable v-model="optForm.opt" size="mini"></el-input>
          </el-form-item>
          <el-form-item>
            <el-button type="primary" size="mini" @click="submitOtp">{{
              $t('btns.confirm')
            }}</el-button>
          </el-form-item>
        </el-form>
      </el-card>
    </el-dialog>
  
  </div>
</template>

<script>
import merchantApi from '@/api/merchant';
import { mapGetters, mapState } from 'vuex';
import moment from 'moment';
import { isNumber, minLenNumber } from '../../../utils/validate';
import RangeDatePicker from '../../cuscom/range-date-picker.vue';
import base from '@/mixin/base.js';
import channelApi from '@/api/channel';
import { getPageCode, openCenteredWindow } from '@/utils';
export default {
  mixins: [base],
  name: 'Clientmanage',
  components: { RangeDatePicker },
  data() {
    return {
      select: [],
      searchLoading: false,
      payoutOrderInfo: {},
      tableLoading: false,
      tableData: [],
      refresh: true,
      refInterval: null,
      formTime: [],
      payoutCountInfo: {},
      form: {
        no: 1,
        size: 100,
        query: {
          merchantNo: '',
          systemOrderNo: '',
          orderNo: '',
          orderStatus: '',
          payoutTimeStart: '',
          payoutTimeEnd: '',
          submitTimeStart: '',
          submitTimeEnd: '',
          accountName: '',
          type: '', //代付类型
          accountNumber: '',
          accountBankCode: ''
        }
      },
      optInfo: {},
      optForm: {
        opt: ''
      },
      optDialogTitle: '',
      showOtpDialog: false,
      otpLoading: false,
      otpRules: [
        {
          required: true,
          validator: (rules, value, cb) => {
            if (!isNumber(value) || !minLenNumber(6, 8)) {
              cb(new Error(this.$t('withdraw.rules.loginName.required').toString()));
            } else {
              cb();
            }
          },
          trigger: 'blur'
        }
      ],
      showQR: false, // 显示二维码
      modalData: {
        cardNumber: '',
        bankCode: '',
        beneficiaryName: ''
      },
      amount: '',
      qrCodeData: {
        attribute5: '',
        qrcode: ''
      }
    };
  },
  computed: {
    ...mapState({
      info: ({ user }) => user.info
    }),
    ...mapGetters(['permission']),
    userType() {
      return this.$store.state.user.userType;
    },
    btnsTime() {
      return this.$t('orders.btns');
    },
    orderStatusCode() {
      return {
        0: this.$t('status.doing2'),
        1: this.$t('status.success5'),
        2: this.$t('status.error'),
        6: this.$t('status.doing'),
        7: this.$t('status.toBeConfirmed'),
        88: this.userType !== 0 ? this.$t('status.success5') : this.$t('status.doing88')
      };
    },
    paymentType() {
      return [
        {
          value: 0,
          label: this.$t('withdraw.label.payoutType1')
        },
        {
          value: 1,
          label: this.$t('withdraw.label.payoutType2')
        }
      ];
    }
  },
  created() {},
  mounted() {
    this.getMerchantPayoutOrderList();
    this.refTableData();
  },
  beforeDestroy() {
    this.refInterval && clearInterval(this.refInterval);
  },
  methods: {

    handleSearch() {
      this.searchLoading = true;
      this.getMerchantPayoutOrderList();
    },
    tableRowClassName({ row, rowIndex }) {
      const orderStatus = row.orderStatus;
      switch (orderStatus) {
        case 0:
          return 'tab-col-blue';
        case 1:
          return 'tab-col-green';
        case 2:
          return 'tab-col-lightcoral';
        case 6:
          return 'tab-col-pink';
        case 7:
          return 'tab-col-red';
        case 88:
          return this.userType !== 0 ? 'tab-col-green' : 'tab-col-red'; //'tab-col-red'
        default:
          return '';
      }
    },
    handleShowDateTime(val) {
      this.formTime = val;
      [this.form.query.submitTimeStart, this.form.query.submitTimeEnd] = val;
    },
    handleShowPayOutTime(val) {
      [this.form.query.payoutTimeStart, this.form.query.payoutTimeEnd] = val;
    },

   
    refTableData() {
      if (this.refresh) {
        this.refInterval = setInterval(() => {
          this.getMerchantPayoutOrderList(true);
        }, 1000 * 60);
      } else {
        clearInterval(this.refInterval);
      }
    },
    async getMerchantPayoutOrderList(isAuto = false) {
      const [submitTimeStart, submitTimeEnd] = this.formTime;
      this.form.query.submitTimeStart = submitTimeStart;
      this.form.query.submitTimeEnd = submitTimeEnd;
      this.tableLoading = true;

      const { data } = await merchantApi.getPayoutOrders({ data: this.form });
      if (data && data.code == 200) {
        this.payoutOrderInfo = data.data;
        this.tableData = data.data.list;
        this.getPayoutCountInfo();
        this.tableLoading = false;
      } else {
        this.tableLoading = false;
        this.$message.error(data.msg || this.$t('status.error'));
      }
      this.searchLoading = false;
    },
    getPayoutCountInfo() {
      const [submitTimeStart, submitTimeEnd] = this.formTime;
      this.form.query.submitTimeStart = submitTimeStart;
      this.form.query.submitTimeEnd = submitTimeEnd;
      merchantApi.getPayoutCount({ data: this.form.query }).then((res) => {
        if (res.data.code == 200) {
          this.payoutCountInfo = res.data.data;
        }
      });
    },
    async handleExport() {
      const [submitTimeStart, submitTimeEnd] = this.formTime;
      this.form.query.submitTimeStart = submitTimeStart;
      this.form.query.submitTimeEnd = submitTimeEnd;
      const { data } = await merchantApi.exportPayoutOrders({ data: this.form.query });
      if (data) {
        const BLOB = data;
        const fileReader = new FileReader();
        fileReader.readAsDataURL(BLOB);
        fileReader.onload = (event) => {
          // 处理load事件。该事件在读取操作完成时触发
          // 新建个下载的a标签，完成后移除。
          let a = document.createElement('a');
          a.download = `Merchant-Payout-Orders-${Number(new Date())}.xlsx`;
          a.href = event.target.result;
          document.body.appendChild(a);
          a.click();
          document.body.removeChild(a);
        };
      } else {
        this.$message.error(data.msg || this.$t('status.error'));
      }
    },
   
    async requestOtp(orderId, bankCode) {
      this.tableLoading = true;
      const { data } = await merchantApi.requestOtp({ id: orderId, bankCode: bankCode });
      if (data.code == 200) {
        this.optInfo = data.data;
        this.tableLoading = false;
        this.$message.success(this.$t('status.success').toString());
        this.getMerchantPayoutOrderList();
        // this.optDialogTitle = `${bankCode}${this.$t("orders.label.table.dispensing")}`;
        // this.showOtpDialog = true;
      } else {
        this.$message.error(data.msg || this.$t('status.error'));
        this.tableLoading = false;
      }
    },
    submitRowOtp(row) {
      if (!this.optInfo || !row.otp || row.otp.length < 6) return;
      this.tableLoading = true;
      this.handleSubmitOtp(row.otp);
    },
    submitOtp() {
      this.$refs.optForm.validate((valid) => {
        if (valid) {
          this.otpLoading = true;
          this.handleSubmitOtp();
        }
      });
    },
    handleSubmitOtp(otp) {
      const params = {
        id: this.optInfo.id,
        bankCode: this.optInfo.accountBankCode,
        otp: otp || this.optForm.opt
      };
      merchantApi.submitOtp(params).then((res) => {
        if (res.data.code == 200) {
          this.$message.success(this.$t('status.success'));
          this.showOtpDialog = false;
          this.otpLoading = false;
          this.tableLoading = false;
          this.getMerchantPayoutOrderList();
        } else {
          this.$message.error(res.data.msg || this.$t('status.error'));
          this.showOtpDialog = false;
          this.otpLoading = false;
          this.tableLoading = false;
        }
      });
    },
    handleEmpty() {
      ((this.form.query = {
        merchantNo: '',
        systemOrderNo: '',
        orderNo: '',
        orderStatus: '',
        payoutTimeStart: '',
        payoutTimeEnd: '',
        submitTimeStart: '',
        submitTimeEnd: '',
        accountName: '',
        type: '', //代付类型
        accountNumber: '',
        accountBankCode: ''
      }),
        (this.form.no = 1));
      this.form.current = 1;
      this.$refs.datePick.handleTime();
      this.$refs.payOutDatePick.handleTime();
    },
    handleTime(type = '') {
      const date = new Date();
      // 当天零点
      const zeroTime = new Date(date.toLocaleDateString()).getTime();
      // 当年
      const nowY = date.getFullYear();
      // 当月
      const nowM = date.getMonth();
      // 当月第一天
      const firstDayNow = new Date(nowY, nowM, 1);
      // 上月第一天
      const firstDayNow1 = new Date(nowY, nowM - 1, 1);
      let start = '';
      let end = '';
      let tempDay = '';
      switch (type) {
        case 'today':
          start = this.timestamp(zeroTime);
          end = this.timestamp(zeroTime + 24 * 60 * 60 * 1000 - 1);
          break;
        case 'yesterday':
          if (this.form.query.payoutTimeStart) {
            tempDay = new Date(
              new Date(this.form.query.payoutTimeStart).toLocaleDateString()
            ).getTime();
            start = this.timestamp(tempDay - 60 * 60 * 24 * 1000);
            end = this.timestamp(tempDay - 1);
          } else {
            start = this.timestamp(zeroTime - 60 * 60 * 24 * 1000);
            end = this.timestamp(new Date(new Date().toLocaleDateString()).getTime() - 1);
          }
          break;
        case 'month':
          start = this.timestamp(firstDayNow);
          end = this.timestamp(zeroTime + 24 * 60 * 60 * 1000 - 1);
          break;
        case 'lastMonth':
          start = this.timestamp(firstDayNow1);
          end = this.timestamp(new Date(firstDayNow).getTime() - 1);
          break;
        default:
          break;
      }
      (console.log(
        '这类似按时地方按时地方。 。。。',
        start,
        end
      )((this.form.query.payoutTimeStart = start)),
        (this.form.query.payoutTimeEnd = end));
    },
    timestamp(time) {
      return moment(time).format('YYYY-MM-DD HH:mm:ss');
    },
    unique(arr, val) {
      const res = new Map();
      return arr.filter((item) => !res.has(item[val]) && res.set(item[val], 1));
    },

    rowKey(row) {
      return row.id;
    },

    handleSelectionChange(list) {
      console.log(list);
      this.select = list;
    },

    // 批量补单
    async allOlder() {
      if (this.select.length == 0) {
        this.$message({
          type: 'info',
          message: this.$t('status.choose')
        });
        return;
      }

      this.$confirm(this.$t('status.worring'), this.$t('status.tip'), {
        confirmButtonText: this.$t('status.confor'),
        cancelButtonText: this.$t('status.Cancel'),
        type: 'warning'
      })
        .then(async () => {
          let ids = this.select.map((it) => it.systemOrderNo);
          let params = {
            patchGoogleCode: 123456,
            systemOrderNos: ids
          };
          this.tableLoading = true;
          const { data } = await merchantApi.allMakeOrder(params);
          if (data.code == 200) {
            this.$message.success(data.msg);
            this.$message({
              type: 'success',
              message: this.$t('status.batchSuccess')
            });
            this.getMerchantPayoutOrderList();
          } else {
            this.$message.error(data.msg);
            this.tableLoading = false;
          }
        })
        .catch(() => {
          this.$message({
            type: 'info',
            message: this.$t('status.cancelOlder')
          });
        });
    },
  }
};
</script>

<style lang="scss" scoped>
.header-table {
  display: flex;
  align-items: center;
  justify-content: space-between;
  background: rgba(0, 0, 0, 0.2);
  padding-right: 40px;

  .list-table {
    display: flex;
    list-style: none;

    li {
      display: flex;
      list-style: none;

      .label {
        font-style: normal;
      }

      .value {
        display: flex;
        list-style: none;
      }
    }

    li:nth-child(n + 2) {
      margin-left: 30px;
    }
  }

  .btn-table {
    margin-left: auto;
  }
}
// .fa {
//   display: inline-block;
//   font: normal normal normal 14px/1 FontAwesome;
//   font-size: inherit;
//   text-rendering: auto;
//   -webkit-font-smoothing: antialiased;
//   -moz-osx-font-smoothing: grayscale;
// }
// .fa-clipboard:before {
//   content: "\f0ea";
// }
.box-card,
.table,
.pag {
  margin-top: 20px;
}

.el-col .el-button:nth-child(1),
.el-col .el-button:nth-child(2) {
  padding: 10px 14px;
}

/deep/ .el-switch__core {
  margin: 0 10px;
}
/deep/ .el-table .tab-col-blue {
  color: blue;
}

/deep/ .el-table .tab-col-green {
  color: green;
}
/deep/ .el-table .tab-col-red {
  color: red;
}
/deep/ .el-table .tab-col-lightcoral {
  color: lightcoral;
}
/deep/ .el-table .tab-col-pink {
  color: #e546f0;
}
.qr-code-box {
  img {
    width: 200px;
    height: 200px;
    display: block;
    margin: auto;
  }
  .input-box {
    display: flex;
    gap: 10px;
    margin: 10px 0;
  }
  .row {
    margin-top: 10px;
  }
}
</style>



// WEBPACK FOOTER //
// src/components/payout/orders/index.vue